export default __webpack_public_path__ + "static/media/logoMain.eeb4d897.png";